import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 003_customers_table — Issue #662 Phase 1 sales slice.
//
// Creates the sales-owned customer table and backfills existing customer rows
// from accounting_partners without deleting or mutating the accounting source.
// Row ids are preserved so existing soft references (quotation.party_id,
// accounting invoice/payment party_id) continue to resolve during transition.
// ============================================================================
export const migration: ModuleMigrationDef = {
  key: "003_customers_table",
  version: "1.0.0",
  ignoreErrors: ["no such table: accounting_partners"],
  sql: `
CREATE TABLE IF NOT EXISTS \`sales_customers\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`partner_code\` text,
  \`partner_name\` text NOT NULL,
  \`is_customer\` integer NOT NULL DEFAULT 1,
  \`is_supplier\` integer NOT NULL DEFAULT 0,
  \`partner_entity_type\` text NOT NULL,
  \`tax_id\` text,
  \`id_card_number\` text,
  \`phone\` text,
  \`email\` text,
  \`address\` text,
  \`notes\` text,
  \`line_id\` text,
  \`credit_limit\` real DEFAULT 0,
  \`payment_term_days\` integer DEFAULT 30,
  \`bank_account_no\` text,
  \`bank_code\` text,
  \`bank_branch\` text,
  \`province\` text,
  \`district\` text,
  \`zip_code\` text,
  \`contact_person\` text,
  \`branch_no\` text,
  \`default_account_id\` text,
  \`default_price_list_id\` text,
  \`custom_data\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);

CREATE INDEX IF NOT EXISTS \`sales_customer_company_idx\`
  ON \`sales_customers\` (\`company_id\`);

CREATE INDEX IF NOT EXISTS \`sales_customer_company_customer_idx\`
  ON \`sales_customers\` (\`company_id\`, \`is_customer\`);

CREATE INDEX IF NOT EXISTS \`sales_customer_company_deleted_idx\`
  ON \`sales_customers\` (\`company_id\`, \`deleted_at\`);

INSERT OR IGNORE INTO \`sales_customers\` (
  \`id\`,
  \`company_id\`,
  \`partner_code\`,
  \`partner_name\`,
  \`is_customer\`,
  \`is_supplier\`,
  \`partner_entity_type\`,
  \`tax_id\`,
  \`id_card_number\`,
  \`phone\`,
  \`email\`,
  \`address\`,
  \`notes\`,
  \`line_id\`,
  \`credit_limit\`,
  \`payment_term_days\`,
  \`bank_account_no\`,
  \`bank_code\`,
  \`bank_branch\`,
  \`province\`,
  \`district\`,
  \`zip_code\`,
  \`contact_person\`,
  \`branch_no\`,
  \`default_account_id\`,
  \`default_price_list_id\`,
  \`custom_data\`,
  \`created_at\`,
  \`created_by\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
)
SELECT
  \`id\`,
  \`company_id\`,
  \`partner_code\`,
  \`partner_name\`,
  1,
  COALESCE(\`is_supplier\`, 0),
  \`partner_entity_type\`,
  \`tax_id\`,
  \`id_card_number\`,
  \`phone\`,
  \`email\`,
  \`address\`,
  \`notes\`,
  \`line_id\`,
  \`credit_limit\`,
  \`payment_term_days\`,
  \`bank_account_no\`,
  \`bank_code\`,
  \`bank_branch\`,
  \`province\`,
  \`district\`,
  \`zip_code\`,
  \`contact_person\`,
  \`branch_no\`,
  \`default_account_id\`,
  \`default_price_list_id\`,
  \`custom_data\`,
  \`created_at\`,
  \`created_by\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
FROM \`accounting_partners\`
WHERE \`is_customer\` = 1;
  `.trim(),
};
